import moment from 'moment';
import { validateEmail } from 'utils/helper';
import { numberUnmask } from 'utils/unmask';
import {
  phoneNumbers,
  middleNumber,
  blockingEmails,
} from 'utils/blockData';

const MedicalTourismSchema = {
  businessName: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  'purpose.code': [{
    rule: 'required',
    error: 'The input field is required',
  }],
  'businessAddresses.country': [{
    rule: 'required',
    error: 'The input field is required',
  }],
  'businessAddresses.address': [{
    rule: 'required',
    error: 'The input field is required',
  }],
  'businessAddresses.city': [{
    rule: 'required',
    error: 'The input field is required',
  }],
  'businessAddresses.state': [{
    rule: 'required',
    error: 'The input field is required',
  }],
  'businessAddresses.zipCode': [{
    rule: 'required',
    error: 'The input field is required',
  }],
  federalTaxIdOrSSN: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  yearsUnderCurrentOwnership: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  ownershipType: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  bankName: [{
    isValid: (input, err, opt, formData) => {
      if (!input && (formData.accountHolderName || formData.routingNumber || formData.accountNumber)) {
        return 'The input field is required';
      }
      return true;
    },
  }],
  accountHolderName: [{
    isValid: (input, err, opt, formData) => {
      if (!input && (formData.bankName || formData.routingNumber || formData.accountNumber)) {
        return 'The input field is required';
      }
      return true;
    },
  }],
  routingNumber: [{
    isValid: (input, err, opt, formData) => {
      if (!input && (formData.bankName || formData.accountHolderName || formData.accountNumber)) {
        return 'The input field is required';
      }

      if (!input && !formData.bankName && !formData.accountHolderName && !formData.accountNumber) {
        return true;
      }

      if (`${input}`.replace('_', '').length < 9) {
        return 'Routing Number is not valid';
      }

      return /^(\d)\1+$/.test(input) ? 'Routing Number is not valid' : true;
    },
  }],
  accountNumber: [{
    isValid: (input, err, opt, formData) => {
      if (!input && (formData.bankName || formData.accountHolderName || formData.routingNumber)) {
        return 'The input field is required';
      }

      return /^(\d)\1+$/.test(input) ? 'Account Number is not valid' : true;
    },
  }],
  'principalOwner.firstName': [{
    rule: 'required',
    error: 'The input field is required',
  }],
  'principalOwner.lastName': [{
    rule: 'required',
    error: 'The input field is required',
  }],
  'principalOwner.address.country': [{
    rule: 'required',
    error: 'The input field is required',
  }],
  'principalOwner.address.address': [{
    rule: 'required',
    error: 'The input field is required',
  }],
  'principalOwner.address.city': [{
    rule: 'required',
    error: 'The input field is required',
  }],
  'principalOwner.address.state': [{
    rule: 'required',
    error: 'The input field is required',
  }],
  'principalOwner.address.zipCode': [
    {
      isValid: (input) => {
        if (!input) {
          return 'The input field is required';
        }
        return input.replace('_', '').length < 5 ? 'Zipcode is not valid' : true;
      },
    },
  ],
  'principalOwner.ssn': [{
    isValid: (input) => {
      if (!input) {
        return true;
      }

      if (numberUnmask(input).length < 11) {
        return 'NSS is not valid';
      }

      return true;
    },
  }],
  'principalOwner.dateOfBirth': [{
    rule: 'required',
    isValid: (input) => {
      if (!input) {
        return 'The input field is required';
      }

      if (numberUnmask(input).length < 8) {
        return 'Date of Birth is not valid';
      }

      if (!moment(input, 'MM/DD/YYYY').isValid()) {
        return 'Date of Birth is not valid';
      }
      return (moment.duration(moment(new Date()).diff(moment(input, 'MM-DD-YYYY'))).asYears()) < 18 ? 'Must be over 18 years old' : true;
    },
  }],
  'principalOwner.email': [{
    rule: 'required',
    isValid: (input) => {
      if (!input) {
        return 'The input field is required';
      }

      return (
        (blockingEmails.indexOf(`${input}`.toLowerCase()) !== -1)
        || !validateEmail(input)
      ) ? 'Email is not valid' : true;
    },
  }],
  'principalOwner.phoneNumber': [{
    isValid: (input) => {
      if (!input) {
        return 'The input field is required';
      }

      return (
        phoneNumbers.indexOf(input || '') !== -1
        || (input && input.charAt(1) === '0')
        || (input && input.charAt(1) === '1')
        || (input && input.substring(6)) === '000-0000'
        || middleNumber.indexOf(Number((input && input.substring(6, 9)) || '')) !== -1
        || (input && input.replace(/\D+/g, '').length < 10) ? 'Phone number is not valid' : true
      );
    },
  }],
  'contacts.firstName': [{
    rule: 'required',
    error: 'The input field is required',
  }],
  'contacts.lastName': [{
    rule: 'required',
    error: 'The input field is required',
  }],
  'contacts.title': [{
    rule: 'required',
    error: 'The input field is required',
  }],
  'contacts.email': [
    'email',
    {
      isValid: (input) => {
        if (!input) {
          return 'The input field is required';
        }

        return blockingEmails.indexOf(input === -1) ? true : 'Email is not valid';
      },
    },
  ],
  'contacts.phoneNumber': [{
    rule: 'required',
    isValid: (input) => {
      if (!input) {
        return 'The input field is required';
      }

      return (
        phoneNumbers.indexOf(input || '') !== -1
        || (input && input.charAt(1) === '0')
        || (input && input.charAt(1) === '1')
        || (input && input.substring(6)) === '000-0000'
        || middleNumber.indexOf(Number((input && input.substring(6, 9)) || '')) !== -1
        || (input && input.replace(/\D+/g, '').length < 10) ? 'Phone number is not valid' : true
      );
    },
  }],
  discountPolicy: [{
    rule: 'required',
    isValid: (input) => (
      input || 'The input field is required'
    ),
  }],
  merchantAgreement: [{
    rule: 'required',
    isValid: (input) => (
      input || 'The input field is required'
    ),
  }],
  'submittedBy.name': [{
    rule: 'required',
    isValid: (input, err, opt, formData) => {
      if (!input) {
        return 'The input field is required';
      }
      return ((input || '').toLowerCase().replace(/\s/g, '') === `${((formData.principalOwner && formData.principalOwner.firstName) || '').toLowerCase().replace(/\s/g, '')}${((formData.principalOwner && formData.principalOwner.lastName) || '').toLowerCase().replace(/\s/g, '')}`) || 'Signature doesn\'t match';
    },
  }],
  'principalOwner.title': [{
    rule: 'required',
    error: 'The input field is required',
  }],
};

export default MedicalTourismSchema;
